import ExportForm from "../common/ExportForm";

const PROJECT_EXPORT_COLUMNS = [
    { key: "projectNumber", label: "Project Number" },
    { key: "organizationName", label: "Client Name" },
    { key: "clientProjectNumber", label: "Client Project Name / Job Number / PM Number" },
    { key: "projectManager", label: "Project Manager" },
    { key: "pipeline", label: "Pipeline" },
    { key: "subPipeline", label: "Sub Pipeline" },
    { key: "stage", label: "Stage" },
    { key: "reportNeeded", label: "Report Needed" },
    { key: "prevailing", label: "Prevailing Job" },
    { key: "cpr", label: "Certified Payroll" },
    { key: "dirNumber", label: "DIR Number" },
    { key: "location", label: "Location" },
    { key: "nearestMedicalFacility", label: "Nearest Medical Facility" },
    { key: "opportunityName", label: "Opportunity Name" },
    { key: "proposalNumber", label: "Proposal Number" },
	{ key: "contactIds", label: "Contacts" },
    { key: "clientPONumber", label: "Client PO" },
    { key: "region", label: "Region" },
    { key: "usaTicketNumber", label: "USA Ticket Number" },
    { key: "usaTicketDate", label: "USA Ticket Date" },
    { key: "billingType", label: "Billing Type" },
    { key: "days", label: "Estimate Days" },
    { key: "laborHours", label: "Estimate Labor Hours" },
    { key: "materialCost", label: "Estimate Material Cost" },
    { key: "budget", label: "Estimate Budget" },
    { key: "description", label: "Description" },
    { key: "notes", label: "Notes" },
    { key: "accurateTime", label: "Accurate Time" },
    { key: "clientSignatureRequired", label: "Client Signature Required" },
    { key: "sendToClient", label: "Send To Client" },
    { key: "creator", label: "Creator" },
    { key: "projectCreationDate", label: "Date Created" },
    { key: "updater", label: "Updater" },
    { key: "projectDateUpdated", label: "Date Updated" },
];

export default function ProjectExportForm() {
    return <ExportForm columns={PROJECT_EXPORT_COLUMNS} />;
}
